import React, { Component } from "react";
import {
  Input,
  Button,
  Form,
  InputNumber,
  Radio, 
  Select,
  Divider,
  message,
} from "antd";
import PhoneInput,{isValidPhoneNumber, parsePhoneNumber} from "react-phone-number-input";
import "react-phone-number-input/style.css";
import DatePicker from "react-multi-date-picker";
import arabic from "react-date-object/calendars/arabic";
import arabic_ar from "react-date-object/locales/arabic_ar";
import momenthijri from "moment-hijri";
import { FaSave, FaTimes } from "react-icons/fa";
import { connect } from "react-redux";
import { EditCustomer, GetCustomerByNIN } from "../../network/customer.network";
import { AiOutlineFileSearch } from "react-icons/ai";
import {
  SyncOutlined,
} from '@ant-design/icons';

const { Option } = Select;
const provinceData = ["Zhejiang", "Jiangsu"];
const cityData = {
  Zhejiang: ["Hangzhou", "Ningbo", "Wenzhou"],
  Jiangsu: ["Nanjing", "Suzhou", "Zhenjiang"],
};

class Customerdata extends Component {
    constructor(props){
      super(props);
      this.timeout =  0;
      this.formRef = React.createRef();
    }
  state = {
    step: 2,
    numberVal: "",
    activeList: "عسكري",
    provinceData: ["عسكري", "Jiangsu"],
    cityData: {
      عسكري: ["رقيب", "ملازم", "عقيد"],
      Jiangsu: ["Nanjing", "Suzhou", "Zhenjiang"],
    },
    customerNID: '',
    typing: false,
    typingTimeout: 0,
    iconLoading : false,
    JobTitlesState : [],
    custId:0,
    jobTitle:null,
    checkJobTitle:false,
    btnSaveLoading:false,
    IsSupport:1,
    IdentityId:''
  };


  componentDidMount(){
    this.searchCustomerNID({target : { value : this.props.NationalIdentityNumber}})
    if(this.props.clientData != null && Object.keys(this.props.clientData).length > 0)
    {
      const {clientData} = this.props
      this.formRef.current.setFieldsValue({
        customerID:clientData.NationalIdentityNumber,
        customerName:clientData.AspNetUsers.FullName,
        customerEmail:clientData.AspNetUsers.Email,
        customerPhone: clientData.AspNetUsers.PhoneKey+clientData.AspNetUsers.PhoneNumber,
        customerArea:clientData.City?.Id?clientData.City?.Id:clientData.CityId,
        customerWorkName:clientData.EmployerName,
        customerSalary:clientData.Salary,
        customerAlt:clientData.HousingAllowance,
        customerTrans:clientData.TransportationAllowance,
        customerGender:clientData.Gender.Id,
        customerBank:clientData.Bank.Id,
        customerDate: momenthijri(clientData.BirthDate).format('iYYYY/iM/iD'),
        support:clientData.IsSupported?1:0,
        employerTitle:clientData.EmployerId,
      });
      this.setState({custId:clientData.Id, IdentityId:clientData.IdentityId});
      const JobTitlesState = this.props.JobTitles?.filter(title => title.EmployerId === clientData.EmployerId);
      this.setState({JobTitlesState, jobTitle : null, employerTitle : clientData.EmployerId});
      this.setState({jobTitle:clientData.JobTitleId});
    }
  }

  searchCustomerNID=(evt)=>{
    var searchText = evt.target.value;
      searchText = this.formRef.current.getFieldValue("customerID") || evt.target.value;
      if(searchText){
        this.setState({iconLoading : true})
        GetCustomerByNIN(searchText,(res)=>{
          let data = res.data.model;
          this.setState({iconLoading : false, numberVal : data.AspNetUsers.PhoneKey + data.AspNetUsers.PhoneNumber})
          this.formRef.current.setFieldsValue({
            customerID:data.NationalIdentityNumber,
            customerName:data.AspNetUsers.FullName,
            customerEmail:data.AspNetUsers.Email,
            customerPhone:data.AspNetUsers.PhoneKey + data.AspNetUsers.PhoneNumber,
            customerArea:data.CityId,
            customerWorkName:data.EmployerName,
            customerSalary:data.Salary,
            customerAlt:data.HousingAllowance,
            customerTrans:data.TransportationAllowance,
            customerGender:data.GenderId,
            customerBank:data.BankId,
            customerDate: momenthijri(data.BirthDate).format('iYYYY/iM/iD'),
            support:data.IsSupported?1:0,
            employerTitle:data.EmployerId,
            
          });
          this.setState({custId:data.Id, IdentityId:data.IdentityId, checkJobTitle:false});
           const JobTitlesState = this.props.JobTitles.filter(title => title.EmployerId === data.EmployerId);
           this.setState({JobTitlesState, jobTitle : null, employerTitle : data.EmployerId});
           this.setState({jobTitle : data.JobTitleId});
        },(error)=>{
          message.info("لم يتم العثور على العميل في النظام");
          this.setState({iconLoading : false})

        })
      }
    // }, 5000);
  }

  changeCustomerNID = (event) => {
    if (this.state.typingTimeout) {
       clearTimeout(this.state.typingTimeout);
    }

    this.setState({
      customerNID: event.target.value,
       typing: false,
       typingTimeout: setTimeout(function () {
           this.sendToParent(this.state.customerNID);
         }, 5000)
    });
}
//-moz-appearance: textfield;
handleEmployerChange = (value) => {
  const JobTitlesState = this.props?.JobTitles.filter(title => title.EmployerId === value);
  this.setState({JobTitlesState, jobTitle : null, employerTitle : value});
  if(value === null) this.setState({checkJobTitle:true});
  else this.setState({checkJobTitle:false});
};

onTitleChange = (value) => {
  this.setState({jobTitle : value});
};

    handelREg = (values) => {
      // console.log(values)
    }
    onFinishFailed = (errorInfo) => {
      if(this.state.jobTitle === null) this.setState({checkJobTitle:true});
      else this.setState({checkJobTitle:false});
      // console.log(errorInfo)
    }

    onFinish=(values)=>{
      if(!values.support) values.support = this.state.IsSupport;
      if(this.state.employerTitle === null) this.setState({checkJobTitle:true});
      else this.setState({checkJobTitle:false});
      if(this.props.showAdd)
      {
        this.setState({btnSaveLoading:true});
        const phoneNumber = parsePhoneNumber(values.customerPhone || "")
        let body= { 
           NationalIdentityNumber:values.customerID,
           EmployerName: values.customerWorkName,
           BirthDate:momenthijri(""+values.customerDate,'iYYYY/iM/iD').format("YYYY-MM-DD"),
           Salary: values.customerSalary,
           HousingAllowance: values.customerAlt,
           TransportationAllowance: values.customerTrans,
           IsSupported: values.support? true:false,
           JobTitleId: this.state.jobTitle,
           EmployerId: this.state.employerTitle,
           GenderId: values.customerGender,
           CityId: values.customerArea,
           BankId: values.customerBank,
           PhoneNumber: phoneNumber.nationalNumber,
           PhoneKey: phoneNumber.countryCallingCode,
           Email: values.customerEmail,
           FullName: values.customerName,
           Id:this.state.custId,
           IdentityId:this.state.IdentityId
         }
         EditCustomer(body,(res)=>{
          message.success("تم تعديل العميل بنجاح");
          this.setState({btnSaveLoading:false});
          this.props.handelShowInfo(res.data.model);
         },(error)=>{
          if(error.Code === 26) message.error("هذا العميل موجود بالفعل")
          else if(error.Code === 24) message.error("البريد الإلكترونى موجود لدى عميل آخر")
          else if(error.Code === 4) message.error("رقم الهاتف موجود بالفعل لعميل آخر")
         this.setState({btnSaveLoading:false});
         });
      }
      else this.props.submitForm(values,[{jobTitle:this.state.jobTitle,employerTitle:this.state.employerTitle,custID:this.state.custId,IdentityId:this.state.IdentityId}]);
    }


    render() {
    const { provinceData, cityData, activeList, iconLoading, employerTitle, jobTitle, JobTitlesState } = this.state;
    const { showAdd, submitForm } = this.props;
    return (
      <div className="finance-tab-content">
        {!showAdd && <h2 className="tab-title">بيانات العميل</h2>}
        <Form
         initialValues={{customerWork: employerTitle && "ccc" }}
          className="form-add-content"
          layout="vertical"
          name="nest-messages"
          onFinish={this.onFinish}  
          onFinishFailed={this.onFinishFailed}
          id="orderForm0"
          ref={this.formRef}
        >
          <div className="form-content">
            <Form.Item
              label="رقم هوية العميل"
              name="customerID"
              className="input-holder"
              rules={[
                  {
                    required: true,
                    message: 'من فضلك ادخل رقم هوية العميل',
                  },
                ]}
            > 
              <Input disabled placeholder="" className="search-addon-user"
               addonAfter={ !iconLoading ? <AiOutlineFileSearch onClick={evt => this.searchCustomerNID(evt)} /> : <SyncOutlined spin />}
               onPressEnter={evt => this.searchCustomerNID(evt)} />
            </Form.Item>
            <Form.Item
              label="اسم العميل"
              name="customerName"
              className="input-holder"
              rules={[
                  {
                    required: true,
                    message: 'من فضلك ادخل اسم العميل',
                  },
                ]}
            >
              <Input placeholder="" />
            </Form.Item>
            <Form.Item
              label="البريد الالكتروني"
              name="customerEmail"
              className="input-holder"
              rules={[
                  {
                    type: 'email',
                    message: 'من فضلك ادخل بريد إلكتروني صحيح',
                  },
                  {
                    required: true,
                    message: 'من فضلك ادخل البريد الإلكتروني',
                  },
                  // {
                  //   pattern: new RegExp('[a-zA-Z0-9]{0,}([.]?[a-zA-Z0-9]{1,})[@](gmail|hotmail|outlook)'),
                  //   message: 'من فضلك ادخل بريد إلكتروني منتهياً ب gmail - outlook - hotmail',
                  // }
                ]}
            >
              <Input placeholder="" />
            </Form.Item>
            <Form.Item
              label="رقم الجوال"
              name="customerPhone"
              className="input-holder"
              rules={[
                // {
                //   validator:this.testPhone,
                // }
              //   {
              //     required: true,
              //     message: 'من فضلك ادخل رقم الجوال',
              //   },
              //   {
              //     len:13,
              //     message: "رقم الجوال غير صحيح",
              // },
                {
                  validator(_, value) {
                    let phoneValid = isValidPhoneNumber(value || "");
                   if(!value) return Promise.reject("من فضلك ادخل رقم الجوال");
                   else if(!phoneValid) return Promise.reject("رقم الجوال غير صحيح");
                   else return Promise.resolve();
                  },
                }
              ]}
            >
              <PhoneInput
                international
                countryCallingCodeEditable={false}
                // countryOption ={["SA"]}  
                defaultCountry="SA"
                value={this.state.numberVal}
                //onChange={(val) =>this.setState({numberVal : val})}
              />
            </Form.Item>
            <Form.Item
              label="تاريخ الميلاد"
              name="customerDate"
              className="input-holder"
              rules={[
                  {
                    required: true,
                    message: 'من فضلك ادخل تاريخ الميلاد',
                  },
                ]}
            >
              <DatePicker
                maxDate={new Date().setFullYear(new Date().getFullYear() - 1, 0, 1)}  
                calendar={arabic} locale={arabic_ar}
              />
              {/* <DatePicker placeholder="" /> */}
            </Form.Item>
            <Form.Item
              label="المنطقة"
              name="customerArea"
              className="input-holder"
              rules={[
                  {
                    required: true,
                    message: 'من فضلك حدد منطقة العميل',
                  },
                ]}
            >
              <Select>
                {this.props.Cities?.map((city)=>{
                  return(<Select.Option key={city.Id} value={city.Id}>{city.NameLT}</Select.Option>)
                })}
              </Select>
            </Form.Item>
            <div>
            <Form.Item
              label=" جهة العمل"
              name="customerWork"
              className="input-holder select-group-holder"
              style={{marginBottom:"0px"}}
            >
              <Select
                value={employerTitle} 
                onChange={this.handleEmployerChange}
              >
                 {this.props.Employers?.map((emp)=>{
                  return(<Select.Option key={emp.Id} value={emp.Id}>{emp.NameLT}</Select.Option>)
                })}
              </Select>
              <Divider style={{ height: 30 }} type="vertical" />
              <Select
                value={jobTitle}
                onChange={this.onTitleChange}
                disabled={employerTitle==2}
              >
                {JobTitlesState.map((title)=>{
                  return(<Select.Option key={title.Id} value={title.Id}>{title.NameLT}</Select.Option>)
                })}
              </Select>
            </Form.Item>
            {this.state.checkJobTitle && <span style={{color:"#fe5252", textAlign:"right", marginTop:"-10px"}}>من فضلك حدد جهة العمل</span>}
            </div>
            <Form.Item
              label=" اسم جهة العمل"
              name="customerWorkName"
              className="input-holder"
              rules={[
                  {
                    required: true,
                    message: 'من فضلك ادخل اسم جهة العمل',
                  },
                ]}
            >
              <Input placeholder="" />
            </Form.Item>
            <Form.Item
              label="الراتب الاساسي"
              name="customerSalary"
              className="input-holder"

              rules={[
                  {
                    required: true,
                    message: 'من فضلك ادخل راتب العميل',
                  },
                ]}
            >
              <InputNumber min={0} />
            </Form.Item>
            <Form.Item
              label="بدل السكن"
              name="customerAlt"
              className="input-holder"
              rules={[
                  {
                    required: true,
                    message: 'من فضلك ادخل بدل السكن',
                  },
                ]}
            >
              <InputNumber min={0}/>
            </Form.Item>
            <Form.Item
              label="بدل النقل"
              name="customerTrans"
              className="input-holder"
              rules={[
                  {
                    required: true,
                    message: 'من فضلك ادخل بدل النقل',
                  },
                ]}
            >
              <InputNumber min={0}/>
            </Form.Item>
            <Form.Item
              label="البنك"
              name="customerBank"
              className="input-holder"
              rules={[
                  {
                    required: true,
                    message: 'من فضلك حدد البنك',
                  },
                ]}
            >
              <Select>
              {this.props.Banks.map((bank)=>{
                  return(<Select.Option key={bank.Id} value={bank.Id}>{bank.NameLT}</Select.Option>)
                })}
              </Select>
            </Form.Item>
            <Form.Item
              label="نوع العميل"
              name="customerGender"
              className="input-holder"
              rules={[
                  {
                    required: true,
                    message: 'من فضلك حدد الجنس',
                  },
                ]}
            >
              <Select>
              {this.props.Genders.map((gender)=>{
                  return(<Select.Option key={gender.Id} value={gender.Id}>{gender.NameLT}</Select.Option>)
                })}
              </Select>
            </Form.Item>
            <Form.Item
              label="مدعوم"
              name="support"
              className="input-holder"
              // rules={[
              //     {
              //       required: true,
              //       message: 'Please input customer phone',
              //     },
              //   ]}
            >
              <Radio.Group name="radiogroup" onChange={e=>this.setState({IsSupport:e.target.value})} defaultValue={1}>
                <Radio value={1}>نعم</Radio>
                <Radio value={0}>لا</Radio>
              </Radio.Group>
            </Form.Item>
          </div>
          {showAdd && (
            <div className="form-add-btns">
              <Button
                type="primary"
                size="large"
                className="blue-btn xlg"
                icon={<FaSave />}
                htmlType="submit"
                loading={this.state.btnSaveLoading}
              >
                حفظ
              </Button>
              <Button
                type="primary"
                size="large"
                className="red-btn xlg"
                onClick={() => this.props.handelShowInfo(null)}
                icon={<FaTimes />}
              >
                الغاء
              </Button>
            </div>
          )}
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  Cities : state.user.metaData?.Cities,   
  Banks : state.user.metaData?.Banks, 
  Genders : state.user.metaData?.Genders, 
  Employers : state.user.metaData?.Employers, 
  NationalIdentityNumber : state.user.currentUser?.NationalIdentityNumber, 
  JobTitles : state.user.metaData?.JobTitles || [], 
}) 
export default connect(mapStateToProps)(Customerdata);  